import type { ProductType } from 'common/enums/product-type.enum';
import type { BaseActionProductDTO, SimilarDTO } from './base-action-product';
import type { FileObject } from 'back-office/services/base-document';
import BaseChangeset from 'common/changesets/base';

export type TestimonyDTO = {
  id?: string;
  firstName: string;
  lastName: string | null;
  role: string | null;
  trainingYear: string | null;
  content: string;
  video: string | null;
  image?: FileObject;
};

export type ProductDTO = BaseActionProductDTO & {
  similarProducts: SimilarDTO[];
  testimonies: TestimonyDTO[];
  type: ProductType;
};

export class ProductChangeset extends BaseChangeset<ProductDTO> {}
